import React from 'react'

function SompoFinal() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center p-12">
        <p className="text-gray-600 text-2xl">
          This has expired. Please contact{' '}
          <a 
            href="mailto:Jeremy.Stevens@charlestaylor.com" 
            className="text-blue-600 hover:text-blue-800 underline text-2xl"
          >
            Jeremy.Stevens@charlestaylor.com
          </a>
        </p>
      </div>
    </div>
  )
}

export default SompoFinal